var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gyh-block"},_vm._l((_vm.data.horizontal),function(d,i){return _c('g-switch-list1',{key:'h' + i,attrs:{"chip":_vm.chip,"horizontal-type":1,"title":d.title,"columns":4,"list":d.list}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2effbde","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageComponents/pk10/gyzh.vue
// module id = null
// module chunks = 